module.exports = __webpack_public_path__ + "static/media/image.4a652fe8.png";